export default "__VITE_ASSET__C6Oe638K__"